var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bundle__location", attrs: { "data-test-dropdown": "" } },
    [
      _c(
        "div",
        {
          staticClass: "location-dropdown",
          class: {
            "location-dropdown--is-open": _vm.isDropDownOpen,
            "location-dropdown--is-disabled": _vm.disabled,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "location-dropdown__value-container",
              attrs: { "data-test-dropdown-switch": "" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.toggleDropdown.apply(null, arguments)
                },
              },
            },
            [
              _vm.selectedItem
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "location-dropdown__value",
                        attrs: {
                          "data-test-dropdown-value": _vm.selectedItem.value,
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.selectedItem.title) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                : _c("div", { staticClass: "location-dropdown__value" }, [
                    _vm._v("\n        Click\n      "),
                  ]),
              _vm._v(" "),
              _c("i", {
                staticClass: "location-dropdown__value-icon fas fa-angle-down",
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "transition",
            {
              attrs: {
                name: "fade",
                "enter-active-class": "fadeIn",
                "leave-active-class": "fadeOut",
              },
            },
            [
              _vm.isDropDownOpen
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.onFocusLeave,
                          expression: "onFocusLeave",
                        },
                      ],
                      staticClass: "location-dropdown__options",
                      style: _vm.dropDownOptionsStyle,
                    },
                    _vm._l(_vm.items, function (group, groupKey) {
                      return _c(
                        "div",
                        { key: groupKey },
                        [
                          group.items.length
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "location-dropdown__options__group",
                                  },
                                  [
                                    group.group
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "location-dropdown__title",
                                          },
                                          [_vm._v(_vm._s(group.group))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      _vm._l(
                                        group.items,
                                        function (item, itemKey) {
                                          return _c("app-dropdown-item", {
                                            key: itemKey,
                                            attrs: { "drop-down-item": item },
                                            on: {
                                              "on-select-dropdown-item":
                                                _vm.onSelectDropdownItem,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }